import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type DeleteLandingPageDomainParams = {
  organizationId: string;
};

export const deleteLandingPageDomain = async (
  params: DeleteLandingPageDomainParams,
): Promise<void> => {
  return await tinctApi.landingPageDomain.deleteLandingPageDomain(
    params.organizationId,
  );
};

/**
 * Remove the workspace landing-page domain. Custom URLs go dead;
 * tinct-domain URLs stay live.
 */
export const useDeleteLandingPageDomain = (
  options?: Omit<
    UseMutationOptions<void, ApiError, DeleteLandingPageDomainParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteLandingPageDomain,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['landing-page-domain', args[1].organizationId],
      });
      // organizationPublishedUrl becomes null on every page.
      queryClient.invalidateQueries({ queryKey: ['landing-pages'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
